import projection from '../generated/pwd5n2f1.json';
import { AcceptanceManifest } from '../types';
export const pwd5n2f1AcceptanceManifest = projection as AcceptanceManifest;
